import { Department } from "models/netsuite";

export const departments = [
  { label: "Sales", value: Department.SALES },
  { label: "PS", value: Department.PS },
];
